/*
 * tp-consent.js — Consent-Bruecke fuer das Storefront-Tracking (Spec 195, §10).
 *
 * Haengt das Tracking-Gate (window.TP_CONSENT) an die Shopify Customer Privacy API.
 * Consentmo speist seine "Statistik-Cookies"-Einwilligung dort als Analytics-Consent
 * ein — das ist der app-unabhaengige, offizielle Vertrag (statt Consentmo-Interna).
 *
 * Bei erteiltem Consent: window.TP_CONSENT = true + TP.ensureStamp() (spaet erteilter
 * Consent stempelt die Cart nachtraeglich, §5/§10). Bei Widerruf: window.TP_CONSENT = false.
 *
 * Muss NACH tp-track.js laden, damit window.TP fuer ensureStamp() existiert.
 */
(function () {
  'use strict';

  function grant() {
    if (window.TP_CONSENT === true) { return; }
    window.TP_CONSENT = true;
    // Spaet erteilter Consent: jetzt erst stempeln (Hook-Pflicht aus §10).
    if (window.TP && window.TP.ensureStamp) { window.TP.ensureStamp(); }
  }

  function revoke() { window.TP_CONSENT = false; }

  // Liest den Analytics-/Statistik-Consent aus der Customer Privacy API.
  // Rueckgabe: true | false | null (API noch nicht da / keine Entscheidung).
  function readConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) { return null; }
      if (typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed();
      }
      if (typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent();
        return !!(c && (c.analytics === 'yes' || c.analytics === true));
      }
    } catch (e) {}
    return null;
  }

  function apply() {
    var ok = readConsent();
    if (ok === true) { grant(); }
    else if (ok === false) { revoke(); }
    // null: API nicht bereit / noch keine Wahl → Default (kein Consent) belassen.
  }

  // 1) Offizielles Shopify-Event, wenn der Besucher seine Wahl trifft/aendert.
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = e && e.detail;
    if (d && (d.analyticsAllowed === true || d.analytics === 'yes')) { grant(); }
    else if (d) { revoke(); }
    else { apply(); }
  });

  // 2) Initiale Auswertung. Die Privacy-API laedt teils spaet → kurz pollen, dann aufhoeren.
  apply();
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if (window.Shopify && window.Shopify.customerPrivacy) { apply(); clearInterval(iv); }
    else if (tries > 40) { clearInterval(iv); }   // ~20 s aufgeben
  }, 500);
})();
